module.exports = __webpack_public_path__ + "img/Etab.f783675a.svg";